import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

export default function useShippingBoIntegrationDisconnect(shop: ShopDto) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const mutation = $api.useMutation("delete", "/shops/{shopId}/integrations/shippingbo");
  const invalidateShop = useInvalidateShop(shop.id);

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async () => {
      return mutation.mutateAsync({ params: { path: { shopId: shop.id } } });
    },
  });
}
